/* eslint-disable @typescript-eslint/ban-ts-comment */
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import PriceInput, { SIZE_CLASSNAMES } from 'app/components/Helpers/PriceInput'
import FormItem, { FormItemProps } from 'app/components/UI-Elements/Forms/_FormItem'
import * as React from 'react'
import { ComponentProps } from 'react'
import { useIntl } from 'react-intl'

interface Props extends FormItemProps {
  disabled?: boolean
  placeholder?: string
  inputProps?: Omit<ComponentProps<typeof PriceInput>, 'size'> & { size?: SizeType }
}

const KPrice: React.FC<Props> = ({
  required,
  name = 'unit_price',
  label,
  disabled,
  placeholder,
  ...others
}) => {
  const { formatMessage } = useIntl()
  const { size = 'large', ...inputProps } = others.inputProps || {}

  const sizeClassName: string = SIZE_CLASSNAMES[size]

  return (
    <FormItem
      hasFeedback={true}
      required={required}
      getValueFromEvent={(value) => value}
      label={label || formatMessage({ id: 'rental.request.product.price' })}
      valuePropName="defaultValue"
      name={name}
      {...others}>
      <PriceInput
        placeholder={placeholder || formatMessage({ id: 'rental.request.product.price' })}
        className={`full-width ant-input ${sizeClassName}`}
        disabled={disabled}
        {...inputProps}
      />
    </FormItem>
  )
}

export default KPrice
